import React from "react";
import {
  LinkCard,
  ProjectsCard,
  ProjectsContainer,
  ProjectsH1,
  ProjectsH2,
  ProjectsIcon,
  ProjectsP,
  ProjectsWrapper,
} from "./ProjectsElements";
import Icon2 from "../../images/github.svg";
import Icon1 from "../../images/covid.svg";
import Icon from "../../images/godelectro.svg";
import Icon3 from "../../images/weather.svg";
import Icon5 from "../../images/house.svg";
import Icon6 from "../../images/bendystav.svg";

const Projects = () => {
  return (
    <ProjectsContainer id="projects">
      <ProjectsH1>My Projects</ProjectsH1>
      <ProjectsWrapper>
        <LinkCard
          href="https://bendystav.cz/"
          target="_blank"
          aria-label="Bendystav"
        >
          <ProjectsCard>
            <ProjectsIcon src={Icon6} />
            <ProjectsH2>Bendystav</ProjectsH2>
            <ProjectsP>
              An application that I created for my friend who runs a
              construction company.{" "}
            </ProjectsP>
          </ProjectsCard>
        </LinkCard>
        <LinkCard
          href="https://pacific-cove-46861.herokuapp.com/"
          target="_blank"
          aria-label="GodElectro"
        >
          <ProjectsCard>
            <ProjectsIcon src={Icon} />
            <ProjectsH2>E-commerce site</ProjectsH2>
            <ProjectsP>
              Full e-commerce site with payments and panel admin(backend and
              frontend).
            </ProjectsP>
          </ProjectsCard>
        </LinkCard>
        <LinkCard
          href="https://covid-e4504.web.app"
          target="_blank"
          aria-label="Covid-19-Tracker"
        >
          <ProjectsCard>
            <ProjectsIcon src={Icon1} />
            <ProjectsH2>Covid-19 Tracker</ProjectsH2>
            <ProjectsP>
              Application that shows how many cases of coronavirus are in the
              world. Is connected with API.
            </ProjectsP>
          </ProjectsCard>
        </LinkCard>
        <LinkCard
          href="https://react-github-users-123.netlify.app/"
          target="_blank"
          aria-label="Github User Search"
        >
          <ProjectsCard>
            <ProjectsIcon src={Icon2} />
            <ProjectsH2>Github User Search</ProjectsH2>
            <ProjectsP>
              Application that shows details about Github users. Is connected
              with Github API and Auth0 authorization.
            </ProjectsP>
          </ProjectsCard>
        </LinkCard>
        <LinkCard
          href="https://weather-app-5fa8b.web.app/"
          target="_blank"
          aria-label="Weather App"
        >
          <ProjectsCard>
            <ProjectsIcon src={Icon3} />
            <ProjectsH2>Weather App</ProjectsH2>
            <ProjectsP>
              Application that shows the weather in your city. Is connected with
              API.
            </ProjectsP>
          </ProjectsCard>
        </LinkCard>
        <LinkCard
          href="https://construction-sit.web.app/"
          target="_blank"
          aria-label="EcoHouse"
        >
          <ProjectsCard>
            <ProjectsIcon src={Icon5} />
            <ProjectsH2>Eco House</ProjectsH2>
            <ProjectsP>
              Example of application of building company. Is fully responsive on
              mobile.{" "}
            </ProjectsP>
          </ProjectsCard>
        </LinkCard>
      </ProjectsWrapper>
    </ProjectsContainer>
  );
};

export default Projects;
